import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { strings } from '@douyinfe/semi-foundation/lib/es/typography/constants';
import Base from './base';
export default class Text extends PureComponent {
  render() {
    return /*#__PURE__*/React.createElement(Base, _Object$assign({
      component: 'span'
    }, this.props));
  }

}
Text.propTypes = {
  copyable: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  delete: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  ellipsis: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  mark: PropTypes.bool,
  underline: PropTypes.bool,
  link: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  strong: PropTypes.bool,
  type: PropTypes.oneOf(strings.TYPE),
  size: PropTypes.oneOf(strings.SIZE),
  style: PropTypes.object,
  className: PropTypes.string,
  code: PropTypes.bool,
  component: PropTypes.string
};
Text.defaultProps = {
  copyable: false,
  delete: false,
  disabled: false,
  icon: '',
  // editable: false,
  ellipsis: false,
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  style: {},
  size: 'normal',
  className: ''
};